export const CARD_TABLE_CLASSES = [
    'rounded-none! border-0! shadow-none!',
    '[&_thead]:bg-transparent [&_tbody]:bg-transparent [&_tbody_tr]:hover:bg-transparent',
    '[&_th]:text-xs [&_th]:font-normal [&_th]:text-mp-muted',
    '[&_th:first-child]:pl-0 [&_td:first-child]:pl-0 [&_th:last-child]:pr-0 [&_td:last-child]:pr-0',
    '[&_td:not(:first-child)]:text-right [&_th:not(:first-child)_div]:justify-end',
].join(' ');

export const TOTAL_ROW_CLASSES =
    '[&_tbody_tr:last-child]:border-t-2 [&_tbody_tr:last-child]:border-mp-border';
